import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="max-w-4xl mx-auto px-6 py-16">
        <h2 className="text-4xl md:text-5xl font-black tracking-tight mb-12" data-testid="privacy-title">Gizlilik Politikası</h2>

        <div className="space-y-8 text-neutral-600 leading-relaxed">
          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">1. Toplanan Bilgiler</h3>
            <p>
              Platform kullanımı sırasında ad, soyad, e-posta adresi, telefon numarası gibi
              kişisel bilgiler toplanabilir. Bu bilgiler yalnızca hizmet sağlama amaçlı kullanılır.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">2. Bilgilerin Kullanımı</h3>
            <p>Toplanan bilgiler aşağıdaki amaçlarla kullanılır:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Ürün gönderim başvurularının işlenmesi</li>
              <li>İletişim taleplerinin yanıtlanması</li>
              <li>Platform hizmetlerinin iyileştirilmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">3. Bilgilerin Paylaşımı</h3>
            <p>
              Kişisel bilgileriniz üçüncü şahıslarla paylaşılmaz.
              Yasal zorunluluklar haricinde bilgileriniz gizli tutulur.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">4. Çerezler (Cookies)</h3>
            <p>
              Platform, kullanıcı deneyimini iyileştirmek için çerezler kullanabilir.
              Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">5. Veri Güvenliği</h3>
            <p>
              Kişisel bilgilerinizin güvenliğini sağlamak için gerekli teknik ve idari tedbirler alınmaktadır.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">6. Haklarınız</h3>
            <p>Kişisel verilerinize ilişkin aşağıdaki haklara sahipsiniz:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Bilgilerinize erişim talep etme</li>
              <li>Bilgilerinizi düzeltme veya silme</li>
              <li>Veri işleme faaliyetlerine itiraz etme</li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-black tracking-tight text-black mb-4">7. İletişim</h3>
            <p>
              Gizlilik politikası hakkında sorularınız için info@testettik.com adresinden bize ulaşabilirsiniz.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-neutral-200">
          <p className="text-sm text-neutral-400">
            Son güncelleme: 25 Ocak 2026
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
